class LegalityList {
    constructor(rules) {
        this.rules = rules;
    }

    validate(deck) {
        const cards = deck.getUniqueCards();

        const restrictedCardsOnList = cards.filter((card) =>
            this.rules.restricted.includes(card.code)
        );
        const bannedCardsOnList = cards.filter((card) => this.rules.banned.includes(card.code));

        const errors = [];

        if (restrictedCardsOnList.length > 1) {
            errors.push(
                `${this.rules.name} - Contains more than 1 card on the restricted list: ${restrictedCardsOnList.map((card) => card.label).join(', ')}`
            );
        }

        if (bannedCardsOnList.length > 0) {
            errors.push(
                `${this.rules.name} - Contains cards on the banned list: ${bannedCardsOnList.map((card) => card.label).join(', ')}`
            );
        }

        const formatPods = this.rules.pods || [];
        const poddedCardsOnList = [];
        for (let i = 0; i < formatPods.length; i++) {
            const pod = formatPods[i];
            const validation = pod.restricted
                ? this.validateRestrictedPods({ pod, cards, number: i + 1 })
                : this.validateAnyCardPod({ pod, cards, number: i + 1 });
            errors.push(...validation.errors);
            poddedCardsOnList.push(...validation.cards);
        }

        return {
            name: this.rules.name,
            valid: errors.length === 0,
            restrictedRules: restrictedCardsOnList.length <= 1,
            errors: errors,
            restrictedCards: restrictedCardsOnList,
            bannedCards: bannedCardsOnList,
            poddedCards: poddedCardsOnList
        };
    }

    validateRestrictedPods({ pod, cards, number }) {
        const validation = {
            errors: [],
            cards: []
        };

        const restrictedCard = cards.find((card) => card.code === pod.restricted);

        if (!restrictedCard) {
            return validation;
        }

        const cardsOnList = cards.filter((card) => pod.cards.includes(card.code));
        if (cardsOnList.length > 0) {
            validation.errors.push(
                `${this.rules.name} - Contains cards that cannot be used with "${restrictedCard.name}" from pod #${number}: ${cardsOnList.map((card) => card.label).join(', ')}`
            );
            validation.cards.push(...cardsOnList);
        }

        return validation;
    }

    validateAnyCardPod({ pod, cards, number }) {
        const validation = {
            errors: [],
            cards: []
        };

        const cardsOnList = cards.filter((card) => pod.cards.includes(card.code));
        if (cardsOnList.length > 1) {
            validation.errors.push(
                `${this.rules.name} - Contains multiple cards from pod #${number}: ${cardsOnList.map((card) => card.label).join(', ')}`
            );
            validation.cards.push(...cardsOnList);
        }

        return validation;
    }
}

export default LegalityList;
